import { Button, Grid } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import ShareLinkDialog from 'features/traceHistory/ShareLinkDialog';
import { MeasurementData } from 'features/weather/types';
import {
  convertFromImperial,
  convertNumberToSaveToDB,
} from 'features/weather/utils/dataConverters';
import { useState } from 'react';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { WeatherConstraint } from './types';
import { getStartDateFromDurationEnum } from './utils/formHelpers';
import { makeShareWeatherUrl } from './utils/urlManagers';

interface Props {
  watch: (names?: string | string[]) => number;
  traceIndex: number;
  weatherConstraints: WeatherConstraint[];
  readyToShare: boolean;
}
const ShareForecastButton = ({
  watch,
  traceIndex,
  weatherConstraints,
  readyToShare,
}: Props) => {
  const [linkUrl, setLinkUrl] = useState('');
  const [linkDialogOpen, setLinkDialogOpen] = useState(false);
  const inImperial = useAppSelector(
    (state) => state.auth.user?.us_customary_units
  );
  const { timezone } = useUserDateTime();
  const handleShareHistory = () => {
    if (typeof window !== 'undefined') {
      const protocol = window.location.protocol;
      const host = window.location.host;
      const urlString = makeShareWeatherUrl(
        protocol,
        host,
        getStartDateFromDurationEnum(watch('duration')),
        new Date(),
        watch('analyzerId'),
        watch('snapshotId'),
        traceIndex,
        weatherConstraints
          .filter(
            (constraint) =>
              constraint.measurement &&
              constraint.level !== null &&
              constraint.level !== undefined &&
              constraint.level !== ''
          )
          .map((constraint) => ({
            ...constraint,
            level:
              // @ts-ignore
              convertFromImperial(
                convertNumberToSaveToDB(
                  Number(constraint.level),
                  constraint.measurement as MeasurementData
                ),
                constraint.measurement as MeasurementData,
                inImperial
              ).toFixed(0),
          })),
        timezone,
        true,
        watch('dish_id')
      );
      setLinkUrl(urlString);
      setLinkDialogOpen(true);
    }
  };
  return (
    <>
      <Grid item>
        <Button
          variant='contained'
          onClick={handleShareHistory}
          disabled={!readyToShare}
        >
          Share
        </Button>
      </Grid>
      <ShareLinkDialog
        open={linkDialogOpen}
        setOpen={setLinkDialogOpen}
        link={linkUrl}
      />
    </>
  );
};

export default ShareForecastButton;
